var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info-card bank-account-display" },
    [
      _c(
        "b-card",
        { staticClass: "d-flex flex-column" },
        [
          _c("h2", { staticClass: "underlined-heading" }, [
            _c("span", [
              _c("i", { staticClass: "inticon-documents" }),
              _vm._v("\n            " + _vm._s(_vm.headline) + "\n        "),
            ]),
            _vm._v(" "),
            _c("span"),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "6" } }, [
                _c("div", { staticClass: "info-card-element" }, [
                  _c("label", [_vm._v("Kontoinhaber")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.bankAccountAttributes.depositor)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "6" } }, [
                _c("div", { staticClass: "info-card-element" }, [
                  _c("label", [_vm._v("IBAN")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.bankAccountAttributes.iban)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "6" } }, [
                _c("div", { staticClass: "info-card-element" }, [
                  _c("label", [_vm._v("Bankname")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.bankAccountAttributes.bankName)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "6" } }, [
                _c("div", { staticClass: "info-card-element" }, [
                  _c("label", [_vm._v("BIC")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.bankAccountAttributes.bic)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "6" } }, [
                _c("div", { staticClass: "info-card-element" }, [
                  _c("label", [_vm._v("PLZ der Bank")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.bankAccountAttributes.postalCode)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "6" } }, [
                _c("div", { staticClass: "info-card-element" }, [
                  _c("label", [_vm._v("Ort der Bank")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.bankAccountAttributes.place)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }